<template>  

  <v-dialog id="dialog" v-model="dialog" max-width="850px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          text
          outlined
          :class="appTunnel ? `green--text mr-1` : `primary--text mr-1`"
          v-bind="attrs"  
          v-on="on"
          x-small
          >
        <span v-if="appTunnel">
          <v-icon x-small class="mr-1 green--text">mdi-earth</v-icon>
          Exposing {{ hostPort }} 
        </span>
        <span v-else>
          Expose {{ hostPort }}
        </span>        
      </v-btn>      
    </template>

    <v-card>
      <v-card-title class="ml-3">Expose application port {{ hostPort }}</v-card-title>
      <v-card-text class="mt-2">
        <span class="ml-3">Synpse can tunnel any HTTP traffic between your device and the internet.          
        </span>
        
        <v-container fluid class="mt-2 mb-2">

          <v-switch
            hide-details
            v-model="appTunnel"
            @click="toggleAppTunnel"
            :label="appTunnel ? `Enabled` : `Disabled`"
          ></v-switch>
          
        </v-container>

        <v-container v-if="appTunnelUrl" fluid class="mt-2 mb-2">
          <span>
            Public URL:
            <a :href="this.appTunnelUrl" target="_blank" rel="noopener">
              {{ appTunnelUrl }}
            </a>

            <v-icon small class="ml-2" @click="copyToClipboard(appTunnelUrl)">mdi-content-copy</v-icon>
          </span>
        </v-container>
      

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text small @click="dialog = false" class="secondary--text"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="stylus">
.addbtn {
  margin: 0px;
  top: auto;
  right: 20px;
  bottom: 20px;
  left: auto;
  position: fixed;
  z-index: 1;
}
</style>

<script>

export default {
  components: {    
  },
  props: {
    application: Object,
    port: String,
    refresh: Function
  },
  data() {
    return {
      dialog: false,
      appTunnel: false,
    }
  },

  mounted() {
    // console.log(this.application)
    this.appTunnel = this.appTunnelUrl != '' ? true : false
  },

  computed: {
    hostPort() {
      // Port comes as mapping 'host:container' as in 8888:8888 for example.
      // we split it in half and then leave only host part
      const [host] = this.port.split(':');
      return host
    },
    project() {
      let project = this.$store.getters.getSelectedProject()
      if (project) {
        return project.name
      }
      return this.application.projectId
    },  
    appTunnelUrl() {
      if (!this.application) {
        return ''
      }

      if (this.application.proxy?.tunnels?.length == 0) {        
        return ''
      }
      
      // Find the tunnel amongst the application tunnels
      let tunnel = this.application.proxy?.tunnels?.find(
        (tunnel) => {
          return tunnel.localPort.toString() === this.hostPort        
        }
      )

      if (tunnel) {
        return tunnel.url
      }

      return ''
    }
  },

  methods: {
    copyToClipboard(val) {
      this.$store.dispatch('Notify', `Copied!`)
      this.$clipboard(val)
    },
    async refreshApp() {
      let q = {
        projectId: this.application.projectId,
        namespaceId: this.application.namespaceId,
        applicationId: this.application.id,
        background: true,        
      }
      // Using refresh function passed as prop, this
      // will refresh app yaml too
      if (this.refresh) {
        this.refresh(false)
        return
      }
      
      await this.$store.dispatch('GetApplication', q)
      
    },
    async toggleAppTunnel() {    
      let application = JSON.parse(JSON.stringify(this.application))

      // If there are no tunnels  then we add the tunnel
      if (application.proxy?.tunnels?.length === 0) {
        application.proxy = {
          tunnels: [
            {
              localPort: parseInt(this.hostPort, 10),
            }
          ]
        }
        // Update the application
        await this.$store.dispatch('UpdateApplication', application)
        
        // await this.$store.dispatch('GetApplication', q)
        await this.refreshApp()

        this.$store.dispatch('Notify', `Application is now accessible from the internet`)
        return
      }
      
      // 1. Iterate over proxy tunnels, if we find the tunnel, then we remove it      
      // 2. If not found, then we add it to the application and update the app

      let found = false
   
      // Use filter to create a new array without the valueToRemove
      let filtered = this.application.proxy?.tunnels?.filter(tunnel => {        
        if (tunnel.localPort.toString() === this.hostPort) {
          // Remove
          found = true
          return false
        }
        // Keep
        return true        
      })

      if (found) {
        application.proxy.tunnels = filtered

        await this.$store.dispatch('UpdateApplication', application)        
        await this.refreshApp()
        return
      }

      if (!application.proxy?.tunnels || application.proxy?.tunnels?.length === 0) {
        application.proxy.tunnels = []
      }
      
      application.proxy.tunnels.push({
        localPort: parseInt(this.hostPort, 10),
      })

      // Update the application
      await this.$store.dispatch('UpdateApplication', application)
            
      await this.refreshApp()

      this.$store.dispatch('Notify', `Application is now accessible from the internet`)
      return
    },
    close() {
      // closing dialog
      // this.$emit('clicked', '')
      this.dialog = false
    }
  }
}
</script>
